var G = window.g
export default {
    serverIp: G.serverIp,
    imgServerIp: G.imgServerIp,
    webSocketIp: G.webSocketIp,
    language:G.language,
    frontendVersion:G.frontendVersion,
    backendVersion:G.backendVersion
}


// WEBPACK FOOTER //
// ./src/components/common/configuration.js